export default __webpack_public_path__ + "static/media/OrganizingLoop1.b1940dea.mp3";